import React from "react";
import './App.css';
import Why from "./Why";
import Footer from "./Footer";
import Header from "./Header";
import Intro from "./Intro";

function App() {
    return (
        <div>
            <div className="mx-auto">
                <div className="intro">
                    <Header/>
                    <Intro/>
                </div>
            </div>
            <div className="mx-auto px-4">
                {/*<div>*/}
                {/*    <Intro/>*/}
                {/*</div>*/}
                <div className="py-2">
                    <Why/>
                </div>
                <div>
                    {/*<Numbers/>*/}
                </div>
                {/*<div className="px-8 p-20">*/}
                {/*    <HIWorks/>*/}
                {/*</div>*/}
                {/*<div className="px-8 p-20">*/}
                {/*    <PlansPrices/>*/}
                {/*</div>*/}
                {/*<div className="px-8 p-20">*/}
                {/*    <FAQ/>*/}
                {/*</div>*/}

                <div className="px-8 p-20">
                    <Footer/>
                </div>
            </div>
        </div>


    );
}

export default App;
